import { render, staticRenderFns } from "./QuoteBuilderPartHeadingsComponent.vue?vue&type=template&id=6237f2da&scoped=true"
import script from "./QuoteBuilderPartHeadingsComponent.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderPartHeadingsComponent.vue?vue&type=script&lang=js"
import style0 from "./QuoteBuilderPartHeadingsComponent.vue?vue&type=style&index=0&id=6237f2da&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6237f2da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6237f2da')) {
      api.createRecord('6237f2da', component.options)
    } else {
      api.reload('6237f2da', component.options)
    }
    module.hot.accept("./QuoteBuilderPartHeadingsComponent.vue?vue&type=template&id=6237f2da&scoped=true", function () {
      api.rerender('6237f2da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/quoteBuilder/ItemTypeComponents/quoteBuilderParts/QuoteBuilderPartHeadingsComponent.vue"
export default component.exports